module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/ETIHAD GUEST SBI PREMIER CARD.7e470e06.png";